<script>
import PlayVideoIcon from "./icons/PlayVideoIcon.vue";
import PlayVideoIconHover from "./icons/PlayVideoIconHover.vue";
import CloseIcon from "./icons/CloseIcon.vue";
import CircCloseIcon from "./icons/CircCloseIcon.vue";

export default {
  components: {
    PlayVideoIcon,
    CloseIcon,
    PlayVideoIconHover,
    CircCloseIcon,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
  },
};
</script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xml:space="preserve"
    class="icon"
    viewBox="0 0 26 26"
  >
    <component :is="name" />
  </svg>
</template>

<style lang="scss" scoped>
svg {
  width: var(--size);
  height: var(--size);
}
path {
  fill: currentColor;
}
</style>



// WEBPACK FOOTER //
// resources/assets/vuejs/frontend/2023-launch/components/AppIconBase.vue